import AxiosClient from "../AxiosClient";

// 産地
export const getOrigin = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 1,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// 階級
export const getProductClass = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 2,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// 等級
export const getRank = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 3,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// 荷姿
export const getPacking = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 4,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// 重量
export const getWeightUnit = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 5,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// 発注単位
export const getOrderingUnit = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 7,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};
// 納品価格
export const getOrderFormColumnCountDirection= () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 10,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};
// 注文票店舗集約
export const getOrderFormShopSummary= () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 11,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};
// 注文表種別分割 										
export const getOrderFormProductTypePartition= () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 12,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};
// 納品価格
export const getUnitPrice = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 13,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};
// 出荷日初期設定	
export const getShippingDateInitialSetting= () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 14,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// 注文票締め切り時間出力
export const getOrderFormDeadlineHourOutput= () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 15,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};
// 	注文票連絡先
export const getOrderFormContact = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 16,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};
// 	注文票注文数量出力
export const getOrderFormOrderQuantityOutput= () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 17,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};
// 販売原票タイプ
export const getSalesRecordType = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 19,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// 帳票タイプ
export const getReceiptDivision = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 20,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// 口座区分
export const getAccountType = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 22,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// 帳票タイプ
export const getClosingDateGroup = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 23,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// 荷主集計区分
export const getCommodityOwnerTotalDivision = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 26,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// 原票商品種別コード
export const getSalesRecordProductType = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 27,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// 納品価格
export const getDeliveryPriceAddition = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 29,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// 帳票タイプ
export const getReportType = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 30,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// 担当者リスト
export const getDirectorEmployee = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 32,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// 地区コード
export const getAreaCdList = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 34,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};

// あて名出力コード
export const getDestinationOutputs = () => {
  const url = "/api/master/var";
  const params = {
    varDiv: 40,
    isDataNotExistIgnore: true,
  };
  return AxiosClient.post(url, params);
};
